/**
 * LR-672: which chrome the Trades section shows for a given mode / History
 * sub-tab. Kept as a pure function so the gating is unit-testable without
 * rendering TradesPage.
 *
 * The counterparty tab (ViewTabBar) is the section's SCOPE axis, orthogonal to
 * the Live / History mode: it shows on the live blotter AND on History → Trades.
 * All Trades stays the global terminal log LR-263 asked for; a counterparty tab
 * makes its scope explicit — before LR-672 the last live pick was applied to
 * History silently, with no way to change it. MetricsBar is live-only (History
 * rows are never open-book). History → Mark to Market / Cash Pool are
 * self-contained logs with their own By date / By counterparty rails (`hview`),
 * so neither the tab bar nor the trades table renders there.
 */
export type TradesMode = 'mtm' | 'history' | undefined;
export type HistoryTab = 'mtm' | 'trades' | 'cashpool' | undefined;

export interface TradesChrome {
  isHistoryMode: boolean;
  /** History → MTM / Cash Pool: a self-contained log replaces the trades table. */
  showHistoryLog: boolean;
  showViewTabBar: boolean;
  showMetricsBar: boolean;
}

export function resolveTradesChrome(mode: TradesMode, htab: HistoryTab): TradesChrome {
  const isHistoryMode = mode === 'history';
  // `htab` defaults to 'trades' when absent (HistorySubTabs contract).
  const showHistoryLog = isHistoryMode && (htab === 'mtm' || htab === 'cashpool');
  return {
    isHistoryMode,
    showHistoryLog,
    showViewTabBar: !showHistoryLog,
    showMetricsBar: !isHistoryMode,
  };
}
